import { cn } from "@/lib/utils";

interface SkeletonProps {
    h?: number;
    className?: string;
}

export function DashSkeleton({ h = 80, className }: SkeletonProps) {
    return (
        <div
            className={cn("bg-gray-100 rounded animate-pulse", className)}
            style={{ height: h }}
        />
    );
}

export function SkelText({ w = "80%" }: { w?: string }) {
    return (
        <span
            className="inline-block h-3 bg-gray-100 rounded animate-pulse align-middle"
            style={{ width: w }}
        />
    );
}
